import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from "prop-types";
import _ from "lodash";
import SimpleReactValidator from "simple-react-validator";
import {findItemValueByIdFromArray} from "functions/find-item-by-id-from-array";
import MerchandiserInvoicingStatuses from "data/merchandiser-invoicing-statuses";
import SearchSelect from "components/common/SearchSelect";
import Spinner from "components/common/Spinner";
import UserTypes from "components/auth/user-types";
import {
    fetchMiscChargeById,
    fetchMiscChargeTypes,
    insertMiscChargeById,
    updateMiscChargeById,
    getMiscChargeRatesSpecific,
    fetchMerchandisers
} from "api/menu/master-files/misc-charges/actions";
import {
    fetchMerchandiserInvoicingJobs,
    fetchRecentCompletedServices,
} from "api/menu/invoicing/actions";
import {
    getTravelTypes
} from "actions/systemListsActions";
import moment from "moment/moment";

class MiscChargeModal extends React.Component {
    dateFormat = "YYYY-MM-DD";

    miscChargeName = {
        travel: "Travel",
        other: "Other",
        parking: "Parking",
        printing: "Printing"
    };

    miscChargeTypeName = {
        kmOnly: "Km Only",
        timeOnly: "Time Only",
        flatRate: "Flat Rate",
        continuity: "Continuity"
    };

    constructor(props) {
        super(props);

        this.state = {
            completedServicesOptions: [],
            miscChargeTypesOptions: [],
            miscChargeMerchandisersOptions: [],
            travelTypesOptions: [],

            miscCharge: {
                employeeId: null,
                miscCharge: "",
                miscChargeId: null,
                amount: 0,
                comments: "",
                isNoJobs: false,
                jobIds: [],
                serviceIds: [],
                approvalStatus: MerchandiserInvoicingStatuses.NotApprovedYet.value,

                units: 0,
                miscChargeRate: 0,
                travelChargeTypeId: 0,
                travelChargeType: ""
            }
        };

        const {user} = this.props.auth;
        this.isMerchandiser =
            user &&
            user.role &&
            user.role.includes(UserTypes.merchandiser) &&
            !user.role.includes(UserTypes.accountManager) &&
            !user.role.includes(UserTypes.admin);

        this.getInputsByType = this.getInputsByType.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleSave = this.handleSave.bind(this);

        this.props.fetchRecentCompletedServices(this.props.merchandiserId, this.props.miscChargeId);

        //if (this.props.merchandiserId) {
          //  if (!Object.keys(this.props.miscChargeRatesSpecific).length) {
                this.props.getMiscChargeRatesSpecific(this.props.merchandiserId);
            //}
        //}

        this.props.getTravelTypes(false);
        this.props.fetchMiscChargeTypes();
        if (!this.isMerchandiser) {
            this.props.fetchMerchandisers();
        }
        if (this.props.miscChargeId) {
            this.props.fetchMiscChargeById(this.props.miscChargeId);
        }

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => (
                <div className="text-danger">{message}</div>
            )
        });
    }

    componentWillReceiveProps(nextProps) {
        const newStates = {};
        if (!_.isEqual(nextProps.miscCharge, this.props.miscCharge) &&
            Object.keys(nextProps.miscCharge).length) {
            // this.props.getMiscChargeRatesSpecific(
            //     nextProps.miscCharge.employeeId,
            //     nextProps.miscCharge.jobIds
            // );
            newStates.miscCharge = nextProps.miscCharge;
        }

        newStates.miscChargeTypesOptions = nextProps.miscChargeTypes.map(value => ({
            label: value.name,
            value: value.id,
        }));
        if (_.isEqual(newStates.miscChargeTypesOptions, this.state.miscChargeTypesOptions)) {
            delete newStates.miscChargeTypesOptions;
        }

        newStates.miscChargeMerchandisersOptions = nextProps.miscChargeMerchandisers.map(value => ({
            label: value.name,
            value: value.id,
        }));
        if (_.isEqual(newStates.miscChargeMerchandisersOptions,
            this.state.miscChargeMerchandisersOptions)) {
            delete newStates.miscChargeMerchandisersOptions;
        }

        newStates.travelTypesOptions = nextProps.travelTypes.map(item => ({
            label: item.value,
            value: item.id
        }));
        if (_.isEqual(newStates.travelTypesOptions, this.state.travelTypesOptions)) {
            delete newStates.travelTypesOptions;
        }

        newStates.completedServicesOptions = nextProps.completedServices.map((value) => ({
            label: `Job# ${value.jobNumber}-Store# ${value.storeNumber}-Date: ${moment(value.completedDate)
                .format(this.dateFormat)}`,
            value: value.serviceID,
        }));
        if (_.isEqual(newStates.completedServicesOptions, this.state.completedServicesOptions)) {
            delete newStates.completedServicesOptions;
        }

        if (Object.keys(newStates).length) {
            this.setState(newStates);
        }
    }

    componentWillUnmount() {
        this.props.fetchMiscChargeById(true);
    }

    handleChange = (ev) => {
        const { miscCharge } = this.state;
        const { name, value } = ev.target;
        miscCharge[name] = value;
        this.setState({
            miscCharge
        });
    };

    getInputsByType = (currentMiscChargeLabel) => {
        const {
            miscChargeRatesSpecific,
            miscChargeId
        } = this.props;

        const {
            miscCharge,
            travelTypesOptions,
            miscChargeMerchandisersOptions
        } = this.state;

        let inputs;

        const travelChargeTypeCurrent = findItemValueByIdFromArray(
            travelTypesOptions,
            "value",
            miscCharge.travelChargeTypeId
        ) || null;

        const currentMiscMerchandiserValue = this.isMerchandiser || findItemValueByIdFromArray(
            miscChargeMerchandisersOptions,
            "value",
            miscCharge.employeeId
        ) || null;

        const isAmountDisabled =
            (miscCharge.miscCharge === "Printing"
                || (miscCharge.miscCharge === "Travel"
                    && (miscCharge.travelChargeType !== this.miscChargeTypeName.flatRate))
                || (miscCharge.miscChargeId === 4
                    && miscCharge.travelChargeTypeId !== 147));

        // if (miscCharge.travelChargeType === this.miscChargeTypeName.flatRate && !miscChargeId) {
        //   miscCharge.amount =  miscChargeRatesSpecific.travelFlatRate;
        // }

        const amountInput = (
            <div className="col-2">
                <div className="form-group">
                    <label>Amount:</label>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">$</span>
                        </div>
                        <input
                            className="form-control"
                            min={0}
                            value={miscCharge.amount || ""}
                            placeholder="0"
                            name="amount"
                            type="number"
                            disabled={isAmountDisabled}
                            onChange={(ev) => this.handleInput("amount", parseFloat(ev.target.value))}
                            onBlur={(ev) => this.handleInput("amount", parseFloat(ev.target.value).toFixed(2))}
                        />
                    </div>
                    {this.validator.message("amount", miscCharge.amount, "required")}
                </div>
            </div>
        );

        switch (currentMiscChargeLabel) {
            case this.miscChargeName.travel: // travel
                inputs = (
                    <div className="row">
                        <div className="col-2">
                            <div className="form-group">
                                <label>Charge Type:</label>
                                <SearchSelect
                                    className="custom-react-select g-filter-select-no-padding"
                                    options={travelTypesOptions}
                                    isClearable={false}
                                    isMulti={false}
                                    isLoading={false}
                                    isDisabled={!currentMiscMerchandiserValue}
                                    value={travelChargeTypeCurrent}
                                    onChange={option => this.handleSelect(option, "travelChargeTypeId")}
                                />
                            </div>
                        </div>

                        {miscCharge.travelChargeType === this.miscChargeTypeName.kmOnly
                            ? (
                                <React.Fragment>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>KM:</label>
                                            <input
                                                className="form-control"
                                                type="number"
                                                step={1}
                                                min={0}
                                                value={miscCharge.units}
                                                disabled={!currentMiscMerchandiserValue}
                                                onChange={ev => this.handleInput("units", {
                                                    type: "km",
                                                    value: ev.target.value
                                                })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Per km rate:</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    readOnly={true}
                                                    value={miscCharge.miscChargeRate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {amountInput}
                                </React.Fragment>
                            )
                            : null}

                        {miscCharge.travelChargeType === this.miscChargeTypeName.timeOnly
                            ? (
                                <React.Fragment>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Hours:</label>
                                            <input
                                                className="form-control"
                                                type="number"
                                                step={1}
                                                min={0}
                                                value={miscCharge.units}
                                                disabled={!currentMiscMerchandiserValue}
                                                onChange={ev => this.handleInput("units", ev.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Per hour rate:</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    readOnly={true}
                                                    value={
                                                        miscChargeRatesSpecific.travelPerHourRate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {amountInput}
                                </React.Fragment>
                            )
                            : null}
                        {miscCharge.travelChargeType === this.miscChargeTypeName.continuity
                            ? (
                                <React.Fragment>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Per service rate:</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    readOnly={true}
                                                    value={miscChargeRatesSpecific.travelContinuity}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Amount:</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    className="form-control"
                                                    min={0}
                                                    value={miscCharge.serviceIds.length * miscChargeRatesSpecific.travelContinuity || ""}
                                                    placeholder="0"
                                                    name="amount"
                                                    type="number"
                                                    disabled={true}
                                                />
                                            </div>
                                            {this.validator.message("amount", miscCharge.amount, "required")}
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                            : null}
                        {miscCharge.travelChargeType === this.miscChargeTypeName.flatRate
                            ? amountInput
                            : null}
                    </div>
                );
                break;
            case this.miscChargeName.printing: // printing
                inputs = (
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Number of pages:</label>
                                <input
                                    className="form-control"
                                    value={miscCharge.units || ""}
                                    type="number"
                                    min={0}
                                    onChange={(ev) => this.handleInput("units", ev.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Per Page Rate:</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">$</span>
                                    </div>
                                    <input
                                        className="form-control"
                                        readOnly={true}
                                        defaultValue={miscChargeRatesSpecific.printPerPageRate}
                                    />
                                </div>
                            </div>
                        </div>

                        {amountInput}
                    </div>
                );
                break;
            default:
                inputs = (
                    <div className="row">
                        {amountInput}
                    </div>
                );
        }

        return inputs;
    };

    handleInput = (name, value) => {
        const miscCharge = Object.assign({}, this.state.miscCharge);
        miscCharge[name] = value;
        if (name === "isNoJobs" && !!value) {
            miscCharge.jobIds = [];
        }
        const { miscChargeRatesSpecific } = this.props;
        if (name === "units") {
            if (typeof value === "object") {
                if (value.type === "km") {
                    miscCharge.units = parseFloat(value.value);


                    miscCharge.miscChargeRate =
                        miscCharge.units < miscChargeRatesSpecific.travelHighLowKmThreshold
                            ? miscChargeRatesSpecific.travelLowKmRate
                            : miscChargeRatesSpecific.travelHighKmRate;
                }
            } else {
                miscCharge.units = parseFloat(value);
            }

            let rate = miscCharge.miscChargeRate;
            if (miscCharge.miscCharge === "Printing" && typeof miscCharge.miscChargeRate === "undefined") {
                rate = miscChargeRatesSpecific.printPerPageRate;
            }
            miscCharge.amount = (rate * miscCharge.units).toFixed(2);
        }

        this.setState({
            miscCharge
        });
    };

    handleSelect = (option, selectName) => {
        const { miscChargeRatesSpecific, auth } = this.props;
        const miscCharge = Object.assign({}, this.state.miscCharge);
        if (selectName === "serviceIds") {
            const jobIdArr = option.map(job => job.value);
            const empId = this.isMerchandiser ? auth.user.nameid : miscCharge.employeeId;
            miscCharge[selectName] = jobIdArr;
            this.props.getMiscChargeRatesSpecific(empId, jobIdArr);
        } else if (selectName === "employeeId") {
            miscCharge[selectName] = option.value;
            this.props.fetchRecentCompletedServices(miscCharge.employeeId, this.props.miscChargeId);
            this.props.getMiscChargeRatesSpecific(miscCharge.employeeId, miscCharge.jobIds);
        } else {
            miscCharge[selectName] = option.value;
        }

        if (selectName === "miscChargeId") {
            miscCharge.miscCharge = option.label;

            // miscCharge.amount = 0;
            // miscCharge.units = 0;
            miscCharge.miscChargeRate = 0;
            miscCharge.travelChargeType = this.miscChargeTypeName.kmOnly;
            miscCharge.travelChargeTypeId = this.state.travelTypesOptions[0]
                ? this.state.travelTypesOptions[0].value : null;

            switch (miscCharge.miscCharge) {
                case this.miscChargeName.travel: // travel
                    miscCharge.miscChargeRate = miscChargeRatesSpecific.travelLowKmRate;
                    miscCharge.travelChargeType = this.miscChargeTypeName.kmOnly;
                    break;
                case this.miscChargeName.printing: // printing
                    miscCharge.miscChargeRate = miscChargeRatesSpecific.printPerPageRate;
                    miscCharge.travelChargeTypeId = 0;
                    miscCharge.travelChargeType = "";
                    break;
                default:
                    miscCharge.miscChargeRate = 0;
                    miscCharge.travelChargeTypeId = 0;
                    miscCharge.travelChargeType = "";
            }
        } else if (selectName === "travelChargeTypeId") {
            miscCharge.travelChargeType = option.label;

            miscCharge.units = 0;
            miscCharge.miscChargeRate = 0;
            miscCharge.amount = 0;

            if (miscCharge.travelChargeType === this.miscChargeTypeName.kmOnly) {
                miscCharge.miscChargeRate = miscChargeRatesSpecific.travelLowKmRate;
            } else if (miscCharge.travelChargeType === this.miscChargeTypeName.timeOnly) {
                miscCharge.miscChargeRate = miscChargeRatesSpecific.travelPerHourRate;
            } else if (miscCharge.travelChargeType === this.miscChargeTypeName.flatRate) {
                miscCharge.miscChargeRate = miscChargeRatesSpecific.printPerPageRate;
            }
        }
        this.setState({
            miscCharge
        });
    };


    handleSave = () => {
        if (this.validator.allValid()) {
            const miscCharge = Object.assign({}, this.state.miscCharge);
            if (miscCharge.travelChargeType === this.miscChargeTypeName.continuity) {
                const { miscChargeRatesSpecific } = this.props;
                miscCharge.units = miscCharge.serviceIds.length;
                miscCharge.amount = miscCharge.units * miscChargeRatesSpecific.travelContinuity;
            }
            if (this.props.miscChargeId) {
                this.props.updateMiscChargeById(
                    this.props.miscChargeId,
                    miscCharge,
                    this.props.onSave
                );
            } else {
                    this.props.insertMiscChargeById(
                        miscCharge,
                        this.props.onSave
                    );
                 }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    render() {
        const {
            loading,
        } = this.props;

        const {
            completedServicesOptions,
            miscChargeTypesOptions,
            miscCharge,
            miscChargeMerchandisersOptions
        } = this.state;

        const currentMiscChargeValue = findItemValueByIdFromArray(
            miscChargeTypesOptions,
            "value",
            miscCharge.miscChargeId
        ) || null;

        const currentMiscMerchandiserValue = this.isMerchandiser || findItemValueByIdFromArray(
            miscChargeMerchandisersOptions,
            "value",
            miscCharge.employeeId
        ) || null;

        const getInputsByType = this.getInputsByType(currentMiscChargeValue
            ? currentMiscChargeValue.label
            : false);

        const currentJobsValue = miscCharge.serviceIds
            ? completedServicesOptions
                .filter(job => miscCharge.serviceIds.indexOf(job.value) > -1)
                .reduce((uniqueJobs, job) => {
                    const existingJob = uniqueJobs.find(
                        item => item.value === job.value && typeof item.value === typeof job.value
                    );
                    if (!existingJob) {
                        uniqueJobs.push(job);
                    }
                    return uniqueJobs;
                }, [])
            : null;

        let title = "";
        Object.keys(MerchandiserInvoicingStatuses).forEach(key => {
            if (MerchandiserInvoicingStatuses[key].value === miscCharge.approvalStatus ||
                MerchandiserInvoicingStatuses[key].key === miscCharge.approvalStatus) {
                title = MerchandiserInvoicingStatuses[key].title;
            }
        });

        return (
            <div className="position-relative">
                {!loading || <Spinner/>}
                {!this.isMerchandiser &&
                <div className="form-group">
                    <label htmlFor="charge">Merchandiser</label>
                    <SearchSelect
                        id="merchandiser"
                        className="custom-react-select"
                        options={miscChargeMerchandisersOptions}
                        isLoading={false}
                        isClearable={false}
                        isSearchable={true}
                        value={currentMiscMerchandiserValue}
                        onChange={(option) => this.handleSelect(option, "employeeId")}
                    />
                    {this.validator.message("miscChargeId", miscCharge.miscChargeId, "required")}
                </div>}
                <div className="form-group">
                    <label htmlFor="charge">Charge</label>
                    <SearchSelect
                        id="charge"
                        className="custom-react-select"
                        options={miscChargeTypesOptions}
                        isLoading={false}
                        isClearable={false}
                        isSearchable={true}
                        value={currentMiscChargeValue}
                        isDisabled={!currentMiscMerchandiserValue}
                        onChange={(option) => this.handleSelect(option, "miscChargeId")}
                    />
                    {this.validator.message("miscChargeId", miscCharge.miscChargeId, "required")}
                </div>
                <div className="form-group">
                    <label htmlFor="jobIds">Completed services</label>
                    <SearchSelect
                        id="jobIds"
                        className="custom-react-select"
                        options={completedServicesOptions}
                        isLoading={false}
                        isClearable={false}
                        isSearchable={true}
                        isMulti={true}
                        value={currentJobsValue}
                        onChange={(option) => this.handleSelect(option, "serviceIds")}
                        isDisabled={!!miscCharge.isNoJobs || !currentMiscMerchandiserValue}
                    />
                </div>
                <div className="custom-control custom-checkbox mb-4">
                    <input
                        type="checkbox"
                        className="custom-control-input"
                        id="isNoJobs"
                        name="isNoJobs"
                        onChange={() => this.handleInput("isNoJobs", !miscCharge.isNoJobs)}
                        disabled={!currentMiscMerchandiserValue}
                        checked={!!miscCharge.isNoJobs}
                    />
                    <label
                        className="custom-control-label"
                        htmlFor="isNoJobs"
                    >
                        Not Job-Related
                    </label>
                    {this.validator.message("jobIds", (miscCharge.serviceIds.length || !!miscCharge.isNoJobs ? "a" : ""), "required")}
                </div>

                {getInputsByType}

                <div className="form-group">
                    <label htmlFor="comments">
                        Comments
                    </label>
                    <textarea
                        id="comments"
                        className="form-control form-control-sm"
                        value={miscCharge.comments || ""}
                        disabled={!currentMiscMerchandiserValue}
                        onChange={(ev) => this.handleInput("comments", ev.target.value)}
                    />
                </div>
                <div className="row">
                    <div className="col-4">
                        <div className="form-group">
                            <label>Status</label>
                            <input
                                className="form-control form-control-sm"
                                type="text"
                                readOnly={true}
                                value={title}
                            />
                        {/* static field "NotApprovedYet" change to miscCharge.approvalStatus */}
                        </div>
                    </div>
                    <div className="col-8">
                        <div className="form-group">
                            <div className="mt-4 text-right">
                                {
                                    this.isMerchandiser ? null :
                                        <React.Fragment>
                                            <button
                                                className="btn btn-success mt-2 mr-2"
                                                onClick={() => this.handleChange({
                                                    target: {
                                                        name: "approvalStatus",
                                                        value:
                                                        MerchandiserInvoicingStatuses.ApprovedByManager.key
                                                    }
                                                })}
                                                disabled={[
                                                    MerchandiserInvoicingStatuses.ApprovedAutomatically.key,
                                                    MerchandiserInvoicingStatuses.ApprovedByManager.key,
                                                ].indexOf(miscCharge.approvalStatus) > -1}
                                            >
                                                Approve
                                            </button>
                                            <button
                                                className="btn btn-danger mr-5 mt-2"
                                                onClick={() => this.handleChange({
                                                    target: {
                                                        name: "approvalStatus",
                                                        value:
                                                        MerchandiserInvoicingStatuses.RejectedByManager.key
                                                    }
                                                })}
                                                disabled={miscCharge.approvalStatus ===
                                                    MerchandiserInvoicingStatuses.RejectedByManager.key}
                                            >
                                                Deny
                                            </button>
                                        </React.Fragment>
                                }
                                <button
                                    className="btn btn-success mt-2 mr-2"
                                    onClick={this.handleSave}
                                >
                                    Accept
                                </button>
                                <button
                                    className="btn btn-danger mt-2"
                                    onClick={this.props.onCancel}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MiscChargeModal.propTypes = {
    miscChargeId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    completedServices: state.invoicing.completedServices,
    loading: state.miscCharges.loading,
    miscChargeRatesSpecific: state.miscCharges.miscChargeRatesSpecific,
    miscChargeTypes: state.miscCharges.miscChargeTypes,
    miscCharge: state.miscCharges.miscCharge,
    miscChargeMerchandisers: state.miscCharges.miscChargeMerchandisers,
    travelTypes: state.systemList.travelTypes,
    auth: state.auth,
});

const mapStateToDispatch = dispatch => ({
    fetchMiscChargeById: bindActionCreators(fetchMiscChargeById, dispatch),
    fetchMiscChargeTypes: bindActionCreators(fetchMiscChargeTypes, dispatch),
    insertMiscChargeById: bindActionCreators(insertMiscChargeById, dispatch),
    updateMiscChargeById: bindActionCreators(updateMiscChargeById, dispatch),
    fetchRecentCompletedServices: bindActionCreators(fetchRecentCompletedServices, dispatch),
    getMiscChargeRatesSpecific: bindActionCreators(getMiscChargeRatesSpecific, dispatch),
    getTravelTypes: bindActionCreators(getTravelTypes, dispatch),
    fetchMerchandisers: bindActionCreators(fetchMerchandisers, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(MiscChargeModal);
